import {Vector3,Vector4,type Group,type Material,type MeshStandardMaterial} from 'three'
import {BALL_RADIUS} from '@core/sim/constants'

/** Private to one palette. Uses the visible ball pool after the normal pose interpolation. */
export function makeGuideBallReflection(source:Material):MeshStandardMaterial {
 const material=source.clone() as MeshStandardMaterial
 material.name='guide.brushedSteel.localBalls'
 const balls=Array.from({length:8},()=>new Vector4()),point=new Vector3(),scale=new Vector3()
 const count={value:0}
 material.userData['guideBalls']={balls,count,point,scale}
 const previous=source.onBeforeCompile.bind(source)
 material.onBeforeCompile=(shader,renderer)=>{
  previous(shader,renderer)
  shader.uniforms['guideBalls']={value:balls};shader.uniforms['guideBallCount']=count
  shader.vertexShader=shader.vertexShader.replace('#include <common>','#include <common>\nvarying vec3 guidePosition;').replace('#include <worldpos_vertex>','#include <worldpos_vertex>\nguidePosition=(modelMatrix*vec4(transformed,1.0)).xyz;')
  shader.fragmentShader=shader.fragmentShader.replace('#include <common>','#include <common>\nvarying vec3 guidePosition;uniform vec4 guideBalls[8];uniform int guideBallCount;')
  shader.fragmentShader=shader.fragmentShader.replace('#include <opaque_fragment>',`
   vec3 gn=inverseTransformDirection(normal,viewMatrix),ge=normalize(cameraPosition-guidePosition),gr=reflect(-ge,gn),hn=vec3(0.0);float nearest=1e6,coverage=0.0;
   for(int i=0;i<8;i++){
    if(i>=guideBallCount)break;
    vec3 delta=guideBalls[i].xyz-guidePosition;float r=guideBalls[i].w,d2=dot(delta,delta),along=dot(delta,gr);
    if(d2>.1225||dot(delta,gn)<=0.0||along<=0.0)continue;
    float p2=max(0.0,d2-along*along),disc=r*r-p2,feather=max(fwidth(p2)*1.3,r*r*.10),mask=smoothstep(-feather,feather,disc),t=along-sqrt(max(0.0,disc));
    if(mask>0.0&&t>0.0&&t<nearest){nearest=t;hn=normalize(gr*t-delta);coverage=mask*(1.0-smoothstep(.0625,.1225,d2));}
   }
   #ifdef USE_ENVMAP
   if(coverage>0.0){vec3 radiance=getIBLRadiance(mat3(viewMatrix)*(-gr),mat3(viewMatrix)*hn,.18)*.56;outgoingLight=mix(outgoingLight,radiance,coverage*.82);}
   #endif
   #include <opaque_fragment>`)
 }
 material.customProgramCacheKey=()=>source.customProgramCacheKey()+'-guide-ball01'
 return material
}

export function updateGuideBallReflection(material:MeshStandardMaterial,group:Group|undefined):void {
 const state=material.userData['guideBalls'] as {balls:Vector4[];count:{value:number};point:Vector3;scale:Vector3}
 state.count.value=0
 if(group===undefined||!group.visible)return
 group.updateWorldMatrix(true,true)
 for(const child of group.children){
  if(!child.visible||state.count.value>=8)continue
  child.getWorldPosition(state.point);const p=state.point
  state.balls[state.count.value++]!.set(p.x,p.y,p.z,BALL_RADIUS*Math.abs(child.getWorldScale(state.scale).x))
 }
}
